<template>
  <div class="newspaperInfoList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item :label="$t('lang.lab_selete')" class="m-0">
          <i class="fa fa-angle-right fa-2x" @click="showAllclick" v-if='showAll'></i>
          <i class="fa fa-angle-down fa-2x" @click="showAllclick" v-else></i>
        </el-form-item>
        <br />
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <!-- 工单完结情况 -->
        <el-form-item>
          <el-select v-model="isEndCondition">
            <el-option key :label="$t('lang.lab_workorder')" value></el-option>
            <el-option v-for="(item,index) in workorderlist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <br /> -->
        <!-- 请选择小区 -->
        <el-form-item>
          <el-select v-model="value" @change="selectFloor">
            <!-- <el-option key :label="$t('lang.lab_selectVillage')" value="0" v-if="diff === false"></el-option> -->
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择楼号 -->
        <el-form-item>
          <el-select v-model="floorid" @change="selectUnit" multiple collapse-tags placeholder="请选择楼号">
            <!-- <el-option key :label="$t('lang.lab_floorName')" value="0"></el-option> -->
            <el-option v-for="(item,index) in floorList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value="0"></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid">
            <el-option key :label="$t('lang.lab_roomName')" value="0"></el-option>
            <el-option v-for="(item,index) in roomList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 是否超时 -->
        <el-form-item>
          <el-select v-model="isOvertime">
            <el-option key :label="$t('lang.lab_isOvertime')" value></el-option>
            <el-option v-for="(item,index) in isOvertimelist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <br /> -->
        <div v-show="showAll">
          <!-- 报事分类一级 -->
          <el-form-item>
            <el-select v-model="firstLevelid" @change="selectSecond">
              <el-option key :label="$t('lang.lab_firstLevel')" value="0"></el-option>
              <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 报事分类二级 -->
          <el-form-item>
            <el-select v-model="secondLevelid" @change="selectThird">
              <el-option key :label="$t('lang.lab_secondLevel')" value="0"></el-option>
              <el-option v-for="(item,index) in secondLevellist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 报事分类三级 -->
          <el-form-item>
            <el-select v-model="thirdLevelid" @change="selectFourth">
              <el-option key :label="$t('lang.lab_thirdLevel')" value="0"></el-option>
              <el-option v-for="(item,index) in thirdLevellist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 报事分类四级 -->
          <el-form-item>
            <el-select v-model="fourthLevelid" @change="selectFifth">
              <el-option key :label="$t('lang.lab_fourthLevel')" value="0"></el-option>
              <el-option v-for="(item,index) in fourthLevellist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 报事分类五级 -->
          <el-form-item>
            <el-select v-model="fifthLevelid">
              <el-option key :label="$t('lang.lab_fifthLevel')" value="0"></el-option>
              <el-option v-for="(item,index) in fifthLevellist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 工单状态 -->
          <el-form-item>
            <el-select v-model="state">
              <el-option key :label="$t('lang.lab_orderstate')" value="0"></el-option>
              <el-option v-for="(item,index) in statelist" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 满意度 -->
          <el-form-item>
            <el-select v-model="evaluate">
              <el-option key :label="$t('lang.lab_evaluate')" value></el-option>
              <el-option v-for="(item,index) in evaluatelist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <br v-if="this.showingPage != 'fourhundred'" />
          <!-- 事件性质 -->
          <el-form-item>
            <el-select v-model="complainFlag">
              <el-option key :label="$t('lang.lab_complainFlag')" value></el-option>
              <el-option v-for="(item,index) in complainFlaglist" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 处理状态：全项目报事信息 报事信息 全项目自动巡检报事-->
          <el-form-item
            v-show="this.showingPage === 'allMaintain'||this.showingPage === 'maintainInfo'||this.showingPage === 'allMaintainQuartzJob'">
            <el-select v-model="propertyStatus">
              <el-option key :label="$t('lang.lab_propertyStatus')" value></el-option>
              <el-option v-for="(item,index) in propertyStatusList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否有图：全项目报事信息 报事信息 全项目自动巡检报事 -->
          <el-form-item
            v-show="this.showingPage === 'allMaintain'||this.showingPage === 'maintainInfo'||this.showingPage === 'allMaintainQuartzJob'">
            <el-select v-model="hasPic">
              <el-option key :label="$t('lang.lab_hasPic')" value></el-option>
              <el-option v-for="(item,index) in hasPicList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 报事来源：全项目报事信息 报事信息 -->
          <el-form-item v-show="this.showingPage === 'allMaintain'||this.showingPage === 'maintainInfo'">
            <el-select v-model="mainSource">
              <el-option key :label="$t('lang.lab_mainSource')" value></el-option>
              <el-option v-for="(item,index) in mainSourceList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否鹰眼报事：全项目报事信息 报事信息 -->
          <el-form-item v-show="this.showingPage === 'allMaintain'||this.showingPage === 'maintainInfo'">
            <el-select v-model="isEagleEye">
              <el-option key :label="$t('lang.lab_isEagleEye')" value></el-option>
              <el-option v-for="(item,index) in haveChildList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否24小时反馈：报事信息 -->
          <el-form-item v-show="this.showingPage === 'maintainInfo'">
            <el-select v-model="isInTime">
              <el-option key :label="$t('lang.lab_isInTime')" value></el-option>
              <el-option v-for="(item,index) in isInTimeList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否代客报事：报事信息 -->
          <el-form-item v-show="this.showingPage === 'maintainInfo'">
            <el-select v-model="isValet">
              <el-option key label="是否代客报事" value></el-option>
              <el-option label="物业代业主报事" value="1"></el-option>
              <el-option label="业主代业主报事" value="2"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <br v-if="this.showingPage === 'maintainInfo'" />
          <!-- 是否审阅：报事信息 -->
          <el-form-item v-show="this.showingPage === 'maintainInfo' || this.showingPage === 'allMaintain'|| this.showingPage === 'allMaintainQuartzJob'">
            <el-select v-model="isCheck">
              <el-option key :label="$t('lang.lab_isCheck')" value></el-option>
              <el-option v-for="(item,index) in isCheckList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否抽审 -->
          <el-form-item>
            <el-select v-model="isRandom" placeholder="抽审状态">
              <el-option label="是否抽审" value></el-option>
              <el-option label="待抽审" :value=1></el-option>
              <el-option label="合格" :value=2></el-option>
              <el-option label="不合格" :value=3></el-option>
              <el-option label="优秀" :value=4></el-option>
            </el-select>
          </el-form-item>
          <!-- 是否稽查工单：报事信息 -->
          <el-form-item v-show="this.showingPage === 'maintainInfo'">
            <el-select v-model="isInspect">
              <el-option key :label="$t('lang.lab_isInspect')" value></el-option>
              <el-option v-for="(item,index) in isInspectList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否有父工单：报事信息 -->
          <el-form-item v-show="this.showingPage === 'maintainInfo'">
            <el-select v-model="haveParent">
              <el-option key :label="$t('lang.lab_haveParent')" value></el-option>
              <el-option v-for="(item,index) in haveParentList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 巡检标准：全项目自动巡检报事 -->
          <el-form-item v-show="this.showingPage === 'allMaintainQuartzJob'">
            <el-select v-model="patrolStandard">
              <el-option key :label="$t('lang.lab_patrolStandard')" value></el-option>
              <el-option v-for="(item,index) in patrolStandardList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 是否有子工单：全项目自动巡检报事 -->
          <el-form-item v-show="this.showingPage === 'allMaintainQuartzJob'">
            <el-select v-model="haveChild">
              <el-option key :label="$t('lang.lab_haveChild')" value></el-option>
              <el-option v-for="(item,index) in haveChildList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 工单评价等级 -->
          <el-form-item>
            <el-select v-model="gradeEvaluation">
              <el-option key label="工单评价等级" value></el-option>
              <el-option v-for="(item,index) in gradeEvaluationList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <br /> -->
          <!-- 手机号或序号或内容input -->
          <el-form-item class="telidcon">
            <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.pla_spaperInfokey')" v-model="keyword">
            </el-input>
          </el-form-item>
          <!-- 接单人input -->
          <el-form-item class="telidcon">
            <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.pla_spaperInfostaffName')" v-model="staffName">
            </el-input>
          </el-form-item>
          <!-- 报单人input -->
          <el-form-item class="telidcon">
            <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.pla_spaperInfosendName')" v-model="sendName">
            </el-input>
          </el-form-item>
          <!-- 关闭自动刷新 -->
          <el-form-item>
            <el-select v-model="refresh" @change="refresh1">
              <el-option v-for="refresh in refreshs" :key="refresh.id" :value="refresh.id" :label="refresh.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="myLaunch">{{$t('lang.lab_myLaunch')}}</el-checkbox>
          </el-form-item>
          <!-- 提交button -->
          <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
          <div style="display: inline-block;">
            <el-select v-model="customColVal" @change="storageCustomColVal" multiple collapse-tags style="margin-left: 20px;width: 220px;" placeholder="请选择">
              <el-option v-for="item in customColList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="light" content='为了您更方便的查看表格数据，您可自定义选择需要展示的数据' placement="right">
              <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
            </el-tooltip>
          </div>
        </div>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" v-if="this.showingPage === 'fourhundred'" @click="jump">
        {{$t('lang.addNewspaperInfoListBtn')}}</el-button>
      <el-button type="primary" slot="header"
        v-if="this.showingPage === 'allMaintain'||this.showingPage === 'maintainInfo'" @click="jump">
        {{$t('lang.btn_addMaintain')}}</el-button>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight539 : require('@/config/enum').tableheight119"
        :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.NewspaperInfoListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- id -->
        <el-table-column prop="id" :label="$t('lang.lab_Id')" width="100px"></el-table-column>
        <!-- 报事用户 -->
        <el-table-column :label="$t('lang.lab_paperusername')" width="250px">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              <el-tooltip placement="top" effect="light"
                v-if="scope.row.user.nickName&&scope.row.user.nickName.length> 20" :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.user.nickName }}</span>
                </div>
                <div>
                  {{ scope.row.user.nickName.substring(0, 10) | valueIsNull }}
                  <span v-if="scope.row.user.nickName.length>10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.user.nickName | valueIsNull }}</div>
              </el-tooltip>
            </div>
            <div v-else>
              <el-tooltip placement="top" effect="light" v-if="scope.row.userName&&scope.row.userName.length> 10"
                :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.userName }}</span>
                </div>
                <div>
                  {{ scope.row.userName.substring(0, 10) | valueIsNull }}
                  <span v-if="scope.row.userName.length>10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.userName | valueIsNull }}</div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- 小区 -->
        <el-table-column :label="$t('lang.lab_papergarden')">
          <template slot-scope="scope">{{ scope.row.garden.name}}</template>
        </el-table-column>
        <!-- 报事方式: 400报事信息 -->
        <el-table-column :label="$t('lang.lab_papertype')" width="150px" v-if="this.showingPage === 'fourhundred'">
          <template slot="header">
            {{ $t('lang.lab_mainSource') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表巡检标准存在异常</div>
            </el-tooltip>
          </template>
          <!-- 后台报事 -->
          <template slot-scope="scope">
            <!-- 后台报事 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperlast')}}</span>
            <!-- GBA设备报事 -->
            <span v-if="scope.row.beginSource === 5"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperGBA')}}</span>
            <!-- 自动巡检工单 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperauto')}}</span>
            <!-- 业主APP报事 -->
            <span v-if="scope.row.beginSource === 2"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperownerapp')}}</span>
            <!-- 物业APP报事 -->
            <span v-if="scope.row.beginSource === 3 && scope.row.quartzJobId == 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperPropertyapp')}}</span>
            <!-- 看板报事 -->
            <span v-if="scope.row.beginSource === 6"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperBoard')}}</span>
            <!-- 400后台补单 -->
            <span v-if="scope.row.beginSource == 4 && scope.row.quartzJobId == 0">{{$t('lang.lab_addback')}}</span>
            <!-- 小程序报事 -->
            <span v-if="scope.row.beginSource === 7"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_wechatApplet')}}</span>
          </template>
        </el-table-column>
        <!-- 报事方式: 全项目报事信息 -->
        <el-table-column :label="$t('lang.lab_mainSource')" width="150px" v-if="this.showingPage === 'allMaintain'&&customColVal.includes('报事来源')">
          <template slot="header">
            {{ $t('lang.lab_mainSource') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表巡检标准存在异常</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <!-- 后台报事 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperlast')}}</span>
            <!-- GBA设备报事 -->
            <span v-if="scope.row.beginSource === 5"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperGBA')}}</span>
            <!-- 自动巡检工单 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperauto')}}</span>
            <!-- 业主APP报事 -->
            <span v-if="scope.row.beginSource === 2"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperownerapp')}}</span>
            <!-- 物业APP报事 -->
            <span v-if="scope.row.beginSource === 3 && scope.row.quartzJobId == 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperPropertyapp')}}</span>
            <!-- 看板报事 -->
            <span v-if="scope.row.beginSource === 6"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperBoard')}}</span>
            <!-- 400后台补单 -->
            <span v-if="scope.row.beginSource == 4 && scope.row.quartzJobId == 0">{{$t('lang.lab_addback')}}</span>
            <!-- 小程序报事 -->
            <span v-if="scope.row.beginSource === 7"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_wechatApplet')}}</span>
              <!-- 扫码报事 -->
            <span v-if="scope.row.beginSource === 11"
              :style="{color:scope.row.isErr===1?'red':''}">扫码报事</span>
            <span v-if="scope.row.beginSource === 13"
              :style="{color:scope.row.isErr===1?'red':''}">合同报事</span> 
              <span v-if="scope.row.beginSource === 14"
              :style="{color:scope.row.isErr===1?'red':''}">资源点位报事</span> 
              <span v-if="scope.row.beginSource === 15"
              :style="{color:scope.row.isErr===1?'red':''}">商城订单配送</span> 
               <span v-if="scope.row.beginSource === 16"
              :style="{color:scope.row.isErr===1?'red':''}">开票工单报事</span> 
          </template>

        </el-table-column>
        <!-- 报事方式: 报事信息 -->
        <el-table-column :label="$t('lang.lab_mainSource')" width="150px" v-if="this.showingPage === 'maintainInfo'&&customColVal.includes('报事来源')">
          <template slot="header">
            {{ $t('lang.lab_mainSource') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表巡检标准存在异常</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <!-- 后台报事 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperlast')}}</span>
            <!-- GBA设备报事 -->
            <span v-if="scope.row.beginSource === 5"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperGBA')}}</span>
            <!-- 自动巡检工单 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperauto')}}</span>
            <!-- 业主APP报事 -->
            <span v-if="scope.row.beginSource === 2"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperownerapp')}}</span>
            <!-- 物业APP报事 -->
            <span v-if="scope.row.beginSource === 3 && scope.row.quartzJobId == 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperPropertyapp')}}</span>
            <!-- 看板报事 -->
            <span v-if="scope.row.beginSource === 6"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperBoard')}}</span>
            <!-- 400后台补单 -->
            <span v-if="scope.row.beginSource == 4 && scope.row.quartzJobId == 0">{{$t('lang.lab_addback')}}</span>
            <!-- 小程序报事 -->
            <span v-if="scope.row.beginSource === 7"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_wechatApplet')}}</span>
              <!-- 扫码报事 -->
            <span v-if="scope.row.beginSource === 11"
              :style="{color:scope.row.isErr===1?'red':''}">扫码报事</span>
            <span v-if="scope.row.beginSource === 13"
              :style="{color:scope.row.isErr===1?'red':''}">合同报事</span>
              <span v-if="scope.row.beginSource === 14"
              :style="{color:scope.row.isErr===1?'red':''}">资源点位报事</span> 
              <span v-if="scope.row.beginSource === 15"
              :style="{color:scope.row.isErr===1?'red':''}">商城订单配送</span> 
               <span v-if="scope.row.beginSource === 16"
              :style="{color:scope.row.isErr===1?'red':''}">开票工单报事</span> 
          </template>
        </el-table-column>
        <!-- 报事方式: 全项目自动巡检报事 -->
        <el-table-column :label="$t('lang.lab_mainSource')" width="150px"
          v-if="this.showingPage === 'allMaintainQuartzJob'&&customColVal.includes('报事来源')">
          <template slot="header">
            {{ $t('lang.lab_mainSource') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表巡检标准存在异常</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <!-- 后台报事 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperlast')}}</span>
            <!-- GBA设备报事 -->
            <span v-if="scope.row.beginSource === 5"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperGBA')}}</span>
            <!-- 自动巡检工单 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperauto')}}</span>
            <!-- 业主APP报事 -->
            <span v-if="scope.row.beginSource === 2"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperownerapp')}}</span>
            <!-- 物业APP报事 -->
            <span v-if="scope.row.beginSource === 3 && scope.row.quartzJobId == 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperPropertyapp')}}</span>
            <!-- 看板报事 -->
            <span v-if="scope.row.beginSource === 6"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperBoard')}}</span>
            <!-- 400后台补单 -->
            <span v-if="scope.row.beginSource == 4 && scope.row.quartzJobId == 0">{{$t('lang.lab_addback')}}</span>
          </template>
        </el-table-column>
        <!-- 报事时间 -->
        <el-table-column :label="$t('lang.lab_papertime')" width="200px" v-if="customColVal.includes('报事时间')" prop="createTime" sortable>
          <template slot="header">
            {{ $t('lang.lab_papertime') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表工单超时</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.isOvertime === 1" class="red">{{scope.row.createTime | time}}</span>
            <span v-else>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
        <!-- 结束时间 -->
        <el-table-column v-if="showingPage === 'allMaintainQuartzJob'&& customColVal.includes('结束时间')" label="结束时间" width="200px" prop="endDate" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.endDate | time}}</span>
          </template>
        </el-table-column>
        <!-- 楼号 -->
        <el-table-column :label="$t('lang.lab_paperhouse')" width="100px" v-if="customColVal.includes('楼号')">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.houseName&&scope.row.garden.grids.houseName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.houseName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.houseName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.houseName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.houseName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 单元号 -->
        <el-table-column :label="$t('lang.lab_paperunit')" width="100px" v-if="customColVal.includes('单元号')">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.unitName&&scope.row.garden.grids.unitName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.unitName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.unitName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.unitName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.unitName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 房间号 -->
        <el-table-column :label="$t('lang.lab_paperroom')" width="100px" v-if="customColVal.includes('房间号')">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.roomName&&scope.row.garden.grids.roomName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.roomName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.roomName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.roomName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.roomName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 报事类型 -->
        <el-table-column :label="$t('lang.lab_papertypes')" width="150px" v-if="customColVal.includes('报事类型')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType1">{{scope.row.maintainType1.name}}</template>
        </el-table-column>
        <el-table-column label="报事类型II" width="150px" v-if="customColVal.includes('报事类型II')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType2">{{scope.row.maintainType2.name}}</template>
        </el-table-column>
        <el-table-column label="报事类型III" width="150px" v-if="customColVal.includes('报事类型III')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType3">{{scope.row.maintainType3.name}}</template>
        </el-table-column>
        <el-table-column label="报事类型Ⅳ" width="150px" v-if="customColVal.includes('报事类型Ⅳ')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType4">{{scope.row.maintainType4.name}}</template>
        </el-table-column>
        <!-- 事件性质: 400报事信息 报事信息 全项目自动巡检报事-->
        <el-table-column :label="$t('lang.lab_papernatureofaffairs')"
          v-if="(this.showingPage === 'fourhundred'||this.showingPage === 'maintainInfo'||this.showingPage === 'allMaintainQuartzJob')&&customColVal.includes('事件性质')">
          <template slot-scope="scope">
            <!-- 0: 事件性质 -->
            <span v-if="scope.row.complainFlag === 0">{{$t('lang.lab_papereno')}}</span>
            <!-- 1: 咨询 -->
            <span v-if="scope.row.complainFlag === 1">{{$t('lang.lab_papereconsult')}}</span>
            <!-- 2: 投诉 -->
            <span v-if="scope.row.complainFlag === 2">{{$t('lang.lab_paperecomplaint')}}</span>
            <!-- 3: 表扬 -->
            <span v-if="scope.row.complainFlag === 3">{{$t('lang.lab_paperecommend')}}</span>
          </template>
        </el-table-column>
        <!-- 事件类别: 全项目报事信息 -->
        <el-table-column :label="$t('lang.lab_complainFlagofType')" v-if="this.showingPage === 'allMaintain'&&customColVal.includes('事件类别')">
          <template slot-scope="scope">
            <!-- 0: 事件性质 -->
            <span v-if="scope.row.complainFlag === 0">{{$t('lang.lab_papereno')}}</span>
            <!-- 1: 咨询 -->
            <span v-if="scope.row.complainFlag === 1">{{$t('lang.lab_papereconsult')}}</span>
            <!-- 2: 投诉 -->
            <span v-if="scope.row.complainFlag === 2">{{$t('lang.lab_paperecomplaint')}}</span>
            <!-- 3: 表扬 -->
            <span v-if="scope.row.complainFlag === 3">{{$t('lang.lab_paperecommend')}}</span>
          </template>
        </el-table-column>
        <!-- 工单属性：全项目报事信息 -->
        <el-table-column width="160px" :label="$t('lang.lab_papereProperty')" v-if="this.showingPage === 'allMaintain'&&customColVal.includes('工单属性')">
          <template slot-scope="scope">
            <!-- 未接单 -->
            <span v-if="scope.row.property === 0" :title="$t('lang.lab_property0')"
              class="property0style">{{$t('lang.lab_property0Abbr')}}</span>
            <!-- 我已接的工单 -->
            <span v-if="scope.row.property === 1" :title="$t('lang.lab_property1')"
              class="property1style">{{$t('lang.lab_property1Abbr')}}</span>
            <!-- 派给我的工单 -->
            <span v-if="scope.row.property === 2" :title="$t('lang.lab_property2')"
              class="property2style">{{$t('lang.lab_property2Abbr')}}</span>
            <!-- 我发起的工单 -->
            <span v-if="scope.row.property === 3" :title="$t('lang.lab_property3')"
              class="property3style">{{$t('lang.lab_property3Abbr')}}</span>
            <!-- Ta人的工单 -->
            <span v-if="scope.row.property === 4" :title="$t('lang.lab_property4')"
              class="property4style">{{$t('lang.lab_property4Abbr')}}</span>
            <!-- 超时的工单 -->
            <span v-if="scope.row.isOvertime === 1" :title="$t('lang.lab_isOvertime1')"
              class="isOvertime1style">{{$t('lang.lab_isOvertime1Abbr')}}</span>
            <!-- 关闭的工单 -->
            <span v-if="scope.row.state === 5" :title="$t('lang.lab_state5')"
              class="state5style">{{$t('lang.lab_state5Abbr')}}</span>
            <!-- 已回访的工单 -->
            <span v-if="scope.row.isFollow === 2" :title="$t('lang.lab_isFollow2')"
              class="isFollow2style">{{$t('lang.lab_isFollow2Abbr')}}</span>
            <!-- 审阅合格 -->
            <span v-if="scope.row.isCheck === 1" :title="$t('lang.lab_isCheck1')"
              class="isCheck1style">{{$t('lang.lab_isCheck1Abbr')}}</span>
            <!-- 审阅不合格 -->
            <span v-if="scope.row.isCheck === 2" :title="$t('lang.lab_isCheck2')"
              class="isCheck2style">{{$t('lang.lab_isCheck2Abbr')}}</span>
          </template>
        </el-table-column>
        <!-- 工单属性：全项目自动巡检报事 -->
        <el-table-column width="160px" :label="$t('lang.lab_papereProperty')"
          v-if="this.showingPage === 'allMaintainQuartzJob'&&customColVal.includes('工单属性')">
          <template slot-scope="scope">
            <!-- 未接单 -->
            <span v-if="scope.row.property === 0" :title="$t('lang.lab_property0')"
              class="property0style">{{$t('lang.lab_property0Abbr')}}</span>
            <!-- 我已接的工单 -->
            <span v-if="scope.row.property === 1" :title="$t('lang.lab_property1')"
              class="property1style">{{$t('lang.lab_property1Abbr')}}</span>
            <!-- 派给我的工单 -->
            <span v-if="scope.row.property === 2" :title="$t('lang.lab_property2')"
              class="property2style">{{$t('lang.lab_property2Abbr')}}</span>
            <!-- 我发起的工单 -->
            <span v-if="scope.row.property === 3" :title="$t('lang.lab_property3')"
              class="property3style">{{$t('lang.lab_property3Abbr')}}</span>
            <!-- Ta人的工单 -->
            <span v-if="scope.row.property === 4" :title="$t('lang.lab_property4')"
              class="property4style">{{$t('lang.lab_property4Abbr')}}</span>
            <!-- 超时的工单 -->
            <span v-if="scope.row.isOvertime === 1" :title="$t('lang.lab_isOvertime1')"
              class="isOvertime1style">{{$t('lang.lab_isOvertime1Abbr')}}</span>
            <!-- 关闭的工单 -->
            <span v-if="scope.row.state === 5" :title="$t('lang.lab_state5')"
              class="state5style">{{$t('lang.lab_state5Abbr')}}</span>
            <!-- 已回访的工单 -->
            <span v-if="scope.row.isFollow === 2" :title="$t('lang.lab_isFollow2')"
              class="isFollow2style">{{$t('lang.lab_isFollow2Abbr')}}</span>
            <!-- 审阅合格 -->
            <span v-if="scope.row.isCheck === 1" :title="$t('lang.lab_isCheck1')"
              class="isCheck1style">{{$t('lang.lab_isCheck1Abbr')}}</span>
            <!-- 审阅不合格 -->
            <span v-if="scope.row.isCheck === 2" :title="$t('lang.lab_isCheck2')"
              class="isCheck2style">{{$t('lang.lab_isCheck2Abbr')}}</span>
            <!-- 子工单 -->
            <span v-if="scope.row.haveChild === 1" :title="$t('lang.lab_haveChild1')" class="haveChild1style"
              @click="haveChildId(scope.row.id)">{{$t('lang.lab_haveChild1Abbr')}}</span>
          </template>
        </el-table-column>
        <!-- 工单属性：报事信息 -->
        <el-table-column width="160px" :label="$t('lang.lab_papereProperty')"
          v-if="this.showingPage === 'maintainInfo'&&customColVal.includes('工单属性')">
          <template slot-scope="scope">
            <!-- 未接单 -->
            <span v-if="scope.row.property === 0" :title="$t('lang.lab_property0')"
              class="property0style">{{$t('lang.lab_property0Abbr')}}</span>
            <!-- 我已接的工单 -->
            <span v-if="scope.row.property === 1" :title="$t('lang.lab_property1')"
              class="property1style">{{$t('lang.lab_property1Abbr')}}</span>
            <!-- 派给我的工单 -->
            <span v-if="scope.row.property === 2" :title="$t('lang.lab_property2')"
              class="property2style">{{$t('lang.lab_property2Abbr')}}</span>
            <!-- 我发起的工单 -->
            <span v-if="scope.row.property === 3" :title="$t('lang.lab_property3')"
              class="property3style">{{$t('lang.lab_property3Abbr')}}</span>
            <!-- Ta人的工单 -->
            <span v-if="scope.row.property === 4" :title="$t('lang.lab_property4')"
              class="property4style">{{$t('lang.lab_property4Abbr')}}</span>
            <!-- 超时的工单 -->
            <span v-if="scope.row.isOvertime === 1" :title="$t('lang.lab_isOvertime1')"
              class="isOvertime1style">{{$t('lang.lab_isOvertime1Abbr')}}</span>
            <!-- 关闭的工单：正常关闭 -->
            <span v-if="scope.row.state === 5" :title="$t('lang.lab_state5_1')"
              class="state5style">{{$t('lang.lab_state5Abbr_1')}}</span>
            <!-- 关闭的工单：非正常关闭 -->
            <span v-if="scope.row.state === 6" :title="$t('lang.lab_state6_1')"
              class="state6style">{{$t('lang.lab_state6Abbr_1')}}</span>
            <!-- 已回访的工单 -->
            <span v-if="scope.row.isFollow === 2" :title="$t('lang.lab_isFollow2')"
              class="isFollow2style">{{$t('lang.lab_isFollow2Abbr')}}</span>
            <!-- 审阅合格 -->
            <span v-if="scope.row.isCheck === 1" :title="$t('lang.lab_isCheck1')"
              class="isCheck1style">{{$t('lang.lab_isCheck1Abbr')}}</span>
            <!-- 审阅不合格 -->
            <span v-if="scope.row.isCheck === 2" :title="$t('lang.lab_isCheck2')"
              class="isCheck2style">{{$t('lang.lab_isCheck2Abbr')}}</span>
            <!-- 代客报事 -->
            <span v-if="scope.row.isValet === 1" :title="$t('lang.lab_isValet1')"
              class="isValet1style">{{$t('lang.lab_isValet1Abbr')}}</span>
            <!-- 稽查报事 -->
            <span v-if="scope.row.isInspect === 1" :title="$t('lang.lab_isInspect1')"
              class="isInspect1style">{{$t('lang.lab_isInspect1Abbr')}}</span>
            <!-- 抄送给我的工单 -->
            <span v-if="scope.row.isCopyToMe === 1" :title="$t('lang.lab_isCopyToMe1')"
              class="isCopyToMe1style">{{$t('lang.lab_isCopyToMe1Abbr')}}</span>
            <!-- 父工单 -->
            <span v-if="scope.row.parentId" :title="$t('lang.lab_haveParentId')" class="haveParentIdstyle"
              @click="detail(scope.row.parentId)">{{$t('lang.lab_haveParentIdAbbr')}}</span>
          </template>
        </el-table-column>
        <!-- 工单状态: 400报事信息 -->
        <el-table-column sortable prop="state" width="120px" :label="$t('lang.lab_paperestate')"
          v-if="this.showingPage === 'fourhundred'&&customColVal.includes('工单状态')">
          <template slot-scope="scope">
            <!-- 0: 报事状态 -->
            <span v-if="scope.row.state === 0">{{$t('lang.lab_paperereportingstate')}}</span>
            <!-- 1: 待确认 -->
            <span v-if="scope.row.state === 1" class="red">{{$t('lang.lab_papereconfirmed')}}</span>
            <!-- 2: 处理中 -->
            <span v-if="scope.row.state === 2">{{$t('lang.lab_paperesolved')}}</span>
            <!-- 3: 已完成 -->
            <span v-if="scope.row.state === 3">{{$t('lang.lab_paperefinsh')}}</span>
            <!-- 4: 已评价 -->
            <span v-if="scope.row.state === 4">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 5: 正常关闭 -->
            <span v-if="scope.row.state === 5">{{$t('lang.lab_paperecloses')}}</span>
            <!-- 6: 非正常关闭 -->
            <span v-if="scope.row.state === 6">{{$t('lang.lab_paperenoclose')}}</span>
            <!-- 7: 已撤销 -->
            <span v-if="scope.row.state === 7">{{$t('lang.lab_fileCancel')}}</span>
            <!-- 8: 已关闭（挂起） -->
            <span v-if="scope.row.state === 8">已关闭（挂起）</span>
          </template>
        </el-table-column>
        <!-- 工单状态：全项目报事信息 报事信息 全项目自动巡检报事 -->
        <el-table-column sortable prop="state" width="120px" :label="$t('lang.lab_paperestate')"
        v-if="(this.showingPage === 'allMaintain'||this.showingPage === 'maintainInfo'||this.showingPage === 'allMaintainQuartzJob')&&customColVal.includes('工单状态')">
          <template slot-scope="scope">
            <!-- 0: 报事状态 -->
            <span v-if="scope.row.state === 0">{{$t('lang.lab_paperereportingstate')}}</span>
            <!-- 1: 待确认 -->
            <span v-if="scope.row.state === 1" class="red">{{$t('lang.lab_papereconfirmed')}}</span>
            <!-- 2: 处理中 -->
            <span v-if="scope.row.state === 2" class="blue">{{$t('lang.lab_paperesolved')}}</span>
            <!-- 3: 已完成 -->
            <span v-if="scope.row.state === 3">{{$t('lang.lab_paperefinsh')}}</span>
            <!-- 4: 已评价 -->
            <span v-if="scope.row.state === 4 && scope.row.isFollow === 2"
              class="green">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 4: 已评价 -->
            <span
              v-if="scope.row.state === 4 && scope.row.isFollow != 2">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 5: 正常关闭 -->
            <span v-if="scope.row.state === 5">{{$t('lang.lab_paperecloses')}}</span>
            <!-- 6: 非正常关闭 -->
            <span v-if="scope.row.state === 6">{{$t('lang.lab_paperenoclose')}}</span>
            <!-- 7: 已撤销 -->
            <span v-if="scope.row.state === 7">已撤销</span>
            <!-- 8: 已关闭（挂起） -->
            <span v-if="scope.row.state === 8">已关闭（挂起）</span>
          </template>
        </el-table-column>
        <!-- 抽审状态 -->
        <el-table-column v-if="customColVal.includes('抽审状态')" label="抽审状态" width="200px" prop="randomState">
          <template slot-scope="scope">
            <!-- 抽审合格 -->
            <span v-if="scope.row.randomState == null" :title="$t('lang.lab_isCheck1')" class="isCheck0style">未抽审</span>
            <!-- 抽审合格 -->
            <span v-if="scope.row.randomState == 1" :title="$t('lang.lab_isCheck1')" class="isCheck0style">待抽审</span>
            <!-- 抽审不合格 -->
            <span v-if="scope.row.randomState == 2" :title="$t('lang.lab_isCheck2')" class="isCheck1style">合格</span>
            <!-- 抽审不合格 -->
            <span v-if="scope.row.randomState == 3" :title="$t('lang.lab_isCheck2')" class="isCheck2style">不合格</span>
            <!-- 抽审不合格 -->
            <span v-if="scope.row.randomState == 4" :title="$t('lang.lab_isCheck2')" class="isCheck1style">优秀</span>
          </template>
        </el-table-column>
        <!-- 接单人 -->
        <el-table-column :label="$t('lang.lab_paperpeople')" width="250px" v-if="customColVal.includes('接单人')">
          <template slot-scope="scope" v-if="scope.row.staffId!= 0&&scope.row.staff!=null&&scope.row.staff.idNo">
            <el-tooltip placement="top" effect="light" v-if="scope.row.staff.idNo&&scope.row.staff.idNo.length> 20"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.staff.idNo }}</span>
              </div>
              <div>
                {{ scope.row.staff.idNo.substring(0, 10) | valueIsNull }}
                <span v-if="scope.row.staff.idNo.length>10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.staff.idNo | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 内容 -->
        <el-table-column :label="$t('lang.lab_papercontent')" prop="content" width="210px" v-if="customColVal.includes('内容')">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.content }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 满意度 -->
        <el-table-column :label="$t('lang.lab_paperevaluate')" prop="evaluate" sortable width="100px" v-if="customColVal.includes('满意度')">
          <template slot-scope="scope">
            <span v-if="scope.row.evaluate === 3" class="red">{{$t('lang.lab_paperenovaluate')}}</span>
            <span v-if="scope.row.evaluate === 0">{{$t('lang.lab_paperevaluateres')}}</span>
            <span v-if="scope.row.evaluate === 1">{{$t('lang.lab_paperevaluateyes')}}</span>
            <span v-if="scope.row.evaluate === 2">{{$t('lang.lab_paperevaluatesoso')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gardenGridName" :label="$t('lang.lab_housekeeper')" v-if="customColVal.includes('管家')" width="250px"></el-table-column>
        <!-- 已完成数量/异常数量/总数量 -->
        <el-table-column width="150px" :label="$t('lang.lab_stateCount')"
          v-if="this.showingPage === 'allMaintainQuartzJob'&&customColVal.includes('已完成/异常/已跳过/总数量')">
          <template slot-scope="scope">
            <span>{{scope.row.finishStateCount}}/{{scope.row.errorStateCount}}/{{scope.row.missStateCount}}/{{scope.row.allStateCount}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" :label="$t('lang.lab_operation')" prop="operation" fixed="right" :width="180">
          <template slot-scope="scope" align="center">
            <el-button v-contextmenu:contextmenu class="operation" @click="detail(scope.row.id,scope.row.haveChild)">
              {{$t('lang.btn_detail')}}</el-button>
            <v-contextmenu ref="contextmenu">
              <v-contextmenu-item @click="jumpNewLink(scope.row.id)">在新标签页打开链接</v-contextmenu-item>
            </v-contextmenu>
            <el-button class="operation" @click="showPhotos(scope.row.id)">{{$t('lang.lab_photodetail')}}</el-button>
            <el-button class="operation" v-if="isSetUp===1" @click="showSetting(scope.row)">{{$t('lang.lab_setBtn')}}</el-button>
            <el-button class="operation orange" v-if="userDataId==100006&&gardenId==0" @click="deleteOne(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="800px"
      :title="$t('lang.lab_quesPicture')">
      <!-- 照片 -->
      <el-form>
        <el-form-item :label="$t('lang.lab_backgroundfilesBefore')">
          <viewer v-if="uris !=''" :images="uris.split(',')" class="img-width">
            <img v-for="(src,index) in uris.split(',')" :src="src" :key="index" class="img">
          </viewer>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundfilesAfter')">
          <viewer v-if="uris_af !=''" :images="uris_af.split(',')" class="img-width">
            <img v-for="(src,index) in uris_af.split(',')" :src="src" :key="index" class="img">
          </viewer>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 设置弹窗 -->
    <el-dialog title="工单评价等级设置" :visible.sync="settingDialogVisible" width="40%" :close-on-click-modal="false">
      <div class='gradeRadio'>
        <span class='gradeRadioLabel'>工单评价等级：</span>
        <el-radio class='gradeRadioValue' v-model="gradeRadio" label="1">优</el-radio>
        <el-radio class='gradeRadioValue' v-model="gradeRadio" label="2">良</el-radio>
        <el-radio class='gradeRadioValue' v-model="gradeRadio" label="0">无</el-radio>
      </div>
      <div class='gradeRemarkBox'>
        <span class='gradeStar'>*</span>
        <el-input class='gradeRemark' type="textarea" :rows="4" placeholder="选择优良时,请输入工单等级评价批注（必填）" v-model="gradeRemark">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingCancel">取 消</el-button>
        <el-button type="primary" @click="settingConfim">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // 引入富文本title汉字
  import {
    excelDownload
  } from '../config/download.js'
  import {
    mapGetters
  } from 'vuex'
  /**
   *@ClassName:newspaperInfoList
   *@Description:400列表
   *@author:孙斯维
   *@Copyright:格众科技
   *@date:2020-03-17
   */
  /**
   *@ClassName:newspaperInfoList
   *@Description:全项目报事信息列表 报事信息列表 全项目自动巡检报事列表
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-04-16
   */
  export default {
    data() {
      return {
        customColList: [{
            value: 'ID',
            label: 'ID',
            disabled: true
          },
          {
            value: '报事用户',
            label: '报事用户',
            disabled: true
          },
          {
            value: '小区',
            label: '小区',
            disabled: true
          },
          {
            value: '报事来源',
            label: '报事来源'
          },
          {
            value: '报事时间',
            label: '报事时间'
          },
          {
            value: '结束时间',
            label: '结束时间'
          },
          {
            value: '楼号',
            label: '楼号'
          },
          {
            value: '单元号',
            label: '单元号'
          },
          {
            value: '房间号',
            label: '房间号'
          },
          {
            value: '报事类型',
            label: '报事类型'
          },
          {
            value: '报事类型II',
            label: '报事类型II'
          },
          {
            value: '报事类型III',
            label: '报事类型III'
          },
          {
            value: '报事类型Ⅳ',
            label: '报事类型Ⅳ'
          },
          {
            value: '事件类别',
            label: '事件类别'
          },
          {
            value: '事件性质',
            label: '事件性质'
          },
          {
            value: '工单属性',
            label: '工单属性'
          },
          {
            value: '工单状态',
            label: '工单状态'
          },
          {
            value: '抽审状态',
            label: '抽审状态'
          },
          {
            value: '接单人',
            label: '接单人'
          },
          {
            value: '内容',
            label: '内容'
          },
          {
            value: '满意度',
            label: '满意度'
          },
          {
            value: '管家',
            label: '管家'
          },
          {
            value: '已完成/异常/已跳过/总数量',
            label: '已完成/异常/已跳过/总数量'
          },
        ], // 自定义展示列数据
        customColVal: ['ID', '报事用户', '小区', '报事来源', '报事时间', '结束时间', '楼号', '单元号', '房间号', '报事类型', '报事类型II', '报事类型III', '报事类型Ⅳ', '事件类别', '事件性质', '工单属性', '工单状态', '抽审状态', '接单人', '内容', '满意度', '管家', '已完成/异常/已跳过/总数量'], // 自定义展示列val
        handleType: '',
        childId: '',
        showAll: true, // 筛选
        diff: false, // 账号权限小区
        multipleSelection: [], // 多选框
        timeOut: '', // 180000刷新
        hasComplain: '', // 接口参数，目前不知道啥用
        complainFlag2: '', // 接口参数，目前不知道啥用
        isQuartzJob: '', // 接口参数，目前不知道啥用
        datevalues: '', // 开始结束时间绑定值
        workorderlist: this.$i18n.t('lang.NewspaperInfoList.workorderlist'), // 工单完结list
        isEndCondition: '', // 工单完结绑定值
        value: '0', // 小区绑定值
        refreshValue: '0', // 小区刷新绑定值
        gardens: [], // 小区下拉列表
        floorid: '0', // 楼层绑定值
        floorList: [], // 楼层下拉列表
        unitid: '0', // 单元绑定值
        unitList: [], // 单元下拉列表
        roomid: '0', // 房间绑定值
        roomList: [], // 房间下拉列表
        patrolStandard: '', // 巡检标准绑定值
        patrolStandardList: [], // 巡检标准列表
        isOvertime: '', // 是否超时绑定值
        isOvertimelist: this.$i18n.t('lang.NewspaperInfoList.isOvertimelist'), // 是否超时list
        state: '0', // 工单状态绑定值
        statelist: this.$i18n.t('lang.NewspaperInfoList.statelist'), // 工单状态list
        evaluate: '', // 满意度绑定值
        evaluatelist: this.$i18n.t('lang.NewspaperInfoList.evaluatelist'), // 满意度list
        complainFlag: '', // 事件性质绑定值
        complainFlaglist: this.$i18n.t('lang.NewspaperInfoList.complainFlaglist'), // 事件性质list
        refresh: '2', // 开启关闭自动刷新绑定值
        refreshs: this.$i18n.t('lang.NewspaperInfoList.refreshs'), // 开启关闭自动刷新list
        propertyStatus: '', // 处理状态绑定值
        propertyStatusList: this.$i18n.t('lang.MaintainsList.propertyStatusList'), // 处理状态list
        hasPic: '', // 是否有图绑定值
        hasPicList: this.$i18n.t('lang.MaintainsList.hasPicList'), // 是否有图list
        mainSource: '', // 报事来源绑定值
        mainSourceList: this.$i18n.t('lang.MaintainsList.mainSourceList'), // 报事来源list
        isInTime: '', // 是否24小时绑定值
        isInTimeList: this.$i18n.t('lang.MaintainsList.isInTimeList'), // 是否24小时list
        isValet: '', // 是否代客报事绑定值
        isCheck: '', // 是否审阅绑定值
        isRandom: '', // 抽审绑定值
        isCheckList: this.$i18n.t('lang.MaintainsList.isCheckList'), // 是否审阅list
        isInspect: '', // 是否稽查工单绑定值
        isInspectList: this.$i18n.t('lang.MaintainsList.isInspectList'), // 是否稽查工单list
        haveParent: '', // 是否有父工单绑定值
        haveParentList: this.$i18n.t('lang.MaintainsList.haveParentList'), // 是否有父工单list
        haveChild: '', // 是否有子工单绑定值
        haveChildList: this.$i18n.t('lang.MaintainsList.haveChildList'), // 是否有子工单list
        gradeEvaluationList: this.$i18n.t('lang.MaintainsList.gradeEvaluationList'), // 工单评价等级list
        isEagleEye: '', // 是否鹰眼报事
        NewspaperInfoListcheckbox: require('@/config/enum')
          .NewspaperInfoListcheckbox, // 是否隐藏复选框
        keyword: '', // 手机或序号内容input
        staffName: '', // 接单人input
        sendName: '', // 报单人input
        pageCount: 0, // 总页数
        pageNum: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        type: 1, // 楼号单元号房间号区分
        firstLevelid: '0', // 一级分类绑定id
        firstLevellist: [], // 一级分类list
        secondLevelid: '0', // 二级分类绑定id
        secondLevellist: [], // 二级分类list
        thirdLevelid: '0', // 三级分类绑定id
        thirdLevellist: [], // 三级分类list
        fourthLevelid: '0', // 四级分类绑定id
        fourthLevellist: [], // 四级分类list
        fifthLevelid: '0', // 五级分类绑定id
        fifthLevellist: [], // 五级分类list
        typeleval: 1, // 级别接口区分字段
        show: false, // 弹框开关
        editId: '', // 编辑页面的ID
        uris: '',
        uris_af: '',
        myLaunch: '', // 我发起的
        settingDialogVisible: false,
        gradeRadio: '0', // 工单评价等级
        gradeRemark: '', // 工单评价等级批注
        gradeEvaluation: '', // 工单评价等级筛选
        maintainId: '', // 工单id
        venueId: '', // 资源点位id
        haveChildParentId: '', // 有子工单的父工单id
      }
    },
    props: ['showingPage'],
    created() {
      // 资源点位报事
      if (this.$route.query.venueId) {
        this.venueId = this.$route.query.venueId
      }
      // 基础数据汇总跳转过来的筛选一级分类为居家服务
      if (this.$route.query.firstLevelid) {
        this.firstLevelid = this.$route.query.firstLevelid
      }
      if (this.showingPage === 'fourhundred') {
        console.log('我是从 400报事 进入的')
        this.value = this.gardenId
        this.complainFlag2 = 0
        this.mainSource = 4
      } else if (this.showingPage === 'allMaintainQuartzJob') {
        console.log('我是从 全项目自动巡检报事 进入的')
        this.value = this.gardenId
        // 全项目自动巡检报事-巡检标准下拉
        this.isQuartzJob = 1
        this.getPatrolStandard()
      } else if (this.showingPage === 'allMaintain') {
        console.log('我是从 全项目报事信息 进入的')
        this.value = this.gardenId
        // 全项目报事信息
      } else if (this.showingPage === 'maintainInfo') {
        console.log('我是从 报事信息 进入的')
        // 报事信息
        if (this.userPermission === '*' || this.gardenId === 0) {
          this.diff = false
        } else {
          this.diff = true
        }
        // if (this.gardenId === 0) {
        //   this.gardenId = '0'
        // }
        this.value = this.gardenId
      }
      this.myGarden()
      this.gardenGrids(this.value)
      // 杜，新增if
      if (window.sessionStorage.getItem('taskManagementForm')) {
        this.taskManageForm = JSON.parse(window.sessionStorage.getItem('taskManagementForm'))
        this.value = this.taskManageForm.value
        this.floorid = this.taskManageForm.floorid
        this.unitid = this.taskManageForm.unitid
        this.roomid = this.taskManageForm.roomid
        this.firstLevelid = this.taskManageForm.firstLevelid
        this.secondLevelid = this.taskManageForm.secondLevelid
        this.thirdLevelid = this.taskManageForm.thirdLevelid
        this.fourthLevelid = this.taskManageForm.fourthLevelid
        this.fifthLevelid = this.taskManageForm.fifthLevelid
        this.pageSize = this.taskManageForm.pageSize
        this.pageNum = this.taskManageForm.pageNum
        this.hasComplain = this.taskManageForm.hasComplain
        this.state = this.taskManageForm.state
        this.mainSource = this.taskManageForm.mainSource
        this.isQuartzJob = this.taskManageForm.isQuartzJob
        this.patrolStandard = this.taskManageForm.patrolStandard
        this.isCheck = this.taskManageForm.isCheck
        this.isRandom = this.taskManageForm.isRandom
        this.isEndCondition = this.taskManageForm.isEndCondition
        this.evaluate = this.taskManageForm.evaluate
        this.datevalues = this.taskManageForm.datevalues // 杜，缓存日期
        this.isOvertime = this.taskManageForm.isOvertime
        this.keyword = this.taskManageForm.keyword
        this.staffName = this.taskManageForm.staffName
        this.sendName = this.taskManageForm.sendName
        this.complainFlag = this.taskManageForm.complainFlag
        this.complainFlag2 = this.taskManageForm.complainFlag2
        this.propertyStatus = this.taskManageForm.propertyStatus
        this.hasPic = this.taskManageForm.hasPic
        this.isInTime = this.taskManageForm.isInTime
        this.isValet = this.taskManageForm.isValet
        this.isInspect = this.taskManageForm.isInspect
        this.haveParent = this.taskManageForm.haveParent
        this.haveChild = this.taskManageForm.haveChild
        this.isEagleEye = this.taskManageForm.isEagleEye
        this.floorList = JSON.parse(this.taskManageForm.floorList)
        this.unitList = JSON.parse(this.taskManageForm.unitList)
        this.roomList = JSON.parse(this.taskManageForm.roomList)
        this.secondLevellist = JSON.parse(this.taskManageForm.secondLevellist)
        this.thirdLevellist = JSON.parse(this.taskManageForm.thirdLevellist)
        this.fourthLevellist = JSON.parse(this.taskManageForm.fourthLevellist)
        this.fifthLevellist = JSON.parse(this.taskManageForm.fifthLevellist)
      }
      // 小区下拉
      if (this.showingPage != 'maintainInfo' && this.showingPage != 'allMaintainQuartzJob' && this.showingPage != 'allMaintain') {
        this.cloundGardens()
      }

      // 一级别下拉
      this.maintainTypes()
      if (this.$route.query.trialDetailList) {
        this.trialDetailList = this.$route.query.trialDetailList
        this.pageNum = 1
        const haveChildParentId = sessionStorage.getItem('haveChildParentId')
        this.haveChildParentId = haveChildParentId
        this.haveChildId(haveChildParentId)
        // sessionStorage.removeItem('haveChildParentId')
      } else {
        this.trialDetailList = false
        sessionStorage.removeItem('haveChildParentId')
        // 查询list
        this.maintains()
      }
      // 获取缓存自定义列
      let customColVal = localStorage.getItem('customColVal')
      if (customColVal) {
        this.customColVal = customColVal.split(',')
      }
    },
    activated() {
      const haveChildParentId = sessionStorage.getItem('haveChildParentId')
      this.haveChildParentId = haveChildParentId
      if (haveChildParentId) {
        // 调用查看子工单方法
        this.haveChildId(haveChildParentId)
        // 清除参数
        // sessionStorage.removeItem('haveChildParentId')
      }
      this.trialDetailList = this.$route.query.trialDetailList ? this.$route.query.trialDetailList : false
    },
    // destroyed() {
    //   clearInterval(this.timeOut)
    //   // 杜，新增
    //   this.taskManageForm = {
    //       value: this.value,
    //       floorid: this.floorid, 
    //       unitid: this.unitid, 
    //       roomid: this.roomid, 
    //       firstLevelid: this.firstLevelid,
    //       secondLevelid: this.secondLevelid,
    //       thirdLevelid: this.thirdLevelid,
    //       fourthLevelid: this.fourthLevelid,
    //       fifthLevelid: this.fifthLevelid,
    //       pageSize: this.pageSize,
    //       pageNum: this.pageNum,
    //       hasComplain: this.hasComplain,
    //       state: this.state,
    //       mainSource: this.mainSource,
    //       isQuartzJob: this.isQuartzJob,
    //       patrolStandard: this.patrolStandard,
    //       isCheck: this.isCheck,
    //       isEndCondition: this.isEndCondition,
    //       evaluate: this.evaluate, 
    //       datevalues: this.datevalues,	// 杜，缓存日期
    //       isOvertime: this.isOvertime,
    //       keyword: this.keyword.trim(),
    //       staffName: this.staffName.trim(),
    //       sendName: this.sendName.trim(),
    //       complainFlag: this.complainFlag,
    //       complainFlag2: this.complainFlag2,
    //       propertyStatus: this.propertyStatus,
    //       hasPic: this.hasPic,
    //       isInTime: this.isInTime,
    //       isInspect: this.isInspect,
    //       haveParent: this.haveParent,
    //       haveChild: this.haveChild,
    //       isEagleEye: this.isEagleEye,
    //       floorList: JSON.stringify(this.floorList), 
    //       unitList: JSON.stringify(this.unitList), 
    //       roomList: JSON.stringify(this.roomList), 
    //       secondLevellist: JSON.stringify(this.secondLevellist), 
    //       thirdLevellist: JSON.stringify(this.thirdLevellist), 
    //   }
    //   console.log(this.taskManageForm)
    //   window.sessionStorage.setItem('taskManagementForm', JSON.stringify(this.taskManageForm))
    // },

    computed: {
      ...mapGetters({
        gardenId: 'gardenId',
        userPermission: 'permission',
        userDataId: 'staffId',
        isSetUp: 'isSetUp'
      })
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        if (this.showingPage === 'maintainInfo') {
          this.value = newFlag
          this.gardenGrids(newFlag)
        }
      },
      'value': function (newVal) {
        this.refreshValue = newVal
      }
    },
    methods: {
      // 缓存自定义列
      storageCustomColVal(val) {
        console.log(val)
        localStorage.setItem('customColVal', val)
      },
      showAllclick() {
        if (this.showAll) {
          this.showAll = false
        } else {
          this.showAll = true
        }
      },
      // 巡检标准下拉-全项目自动巡检报事
      getPatrolStandard() {
        this.$get(
          `patrolStandard/?maintainType1=0&maintainType2=0&maintainType3=0&pageNo=1&pageSize=999`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              this.patrolStandardList = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 点击父工单(未验证)
      haveParentId(id) {
        this.$get(`maintains/${id}`).then(
          res => {
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 点击子工单(未验证)
      haveChildId(id) {
        this.childId = id
        this.$get(`maintains?parentId=${id}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`).then(
          res => {
            if (res && res.errCode === 0) {
              this.handleType = 'child'
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // 对应table数据的列字段名
          let newArr = []
          let userName = ''
          let gardenName = ''
          let beginSource = ''
          let houseName = ''
          let unitName = ''
          let roomName = ''
          let maintainType1 = ''
          let maintainType2 = ''
          let maintainType3 = ''
          let maintainType4 = ''
          let complainFlag = ''
          let property = ''
          let state = ''
          let evaluate = ''
          let stateCount = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              // 判断报事用户是否存在
              if (this.tableData[i].user) {
                userName = this.tableData[i].user.nickName
              } else {
                userName = this.tableData[i].userName
              }
              // 判断小区楼号单元房间号是否存在
              if (this.tableData[i].garden) {
                gardenName = this.tableData[i].garden.name
              }
              if (this.tableData[i].garden.grids) {
                houseName = this.tableData[i].garden.grids.houseName
                unitName = this.tableData[i].garden.grids.unitName
                roomName = this.tableData[i].garden.grids.roomName
              }
              // 判断报事方式
              if (this.showingPage === 'fourhundred') {
                // 400报事方式
                if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId === 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperlast')
                } else if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId > 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperauto')
                } else if (this.tableData[i].beginSource === 2) {
                  beginSource = this.$i18n.t('lang.lab_paperownerapp')
                } else if (
                  this.tableData[i].beginSource === 3 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperPropertyapp')
                } else if (
                  this.tableData[i].beginSource === 4 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_addback')
                } else if (
                  this.tableData[i].beginSource === 5 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperGBA')
                }
              } else if (this.showingPage === 'allMaintain') {
                // 全项目报事信息报事方式
                if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId === 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperlast')
                } else if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId > 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperauto')
                } else if (this.tableData[i].beginSource === 2) {
                  beginSource = this.$i18n.t('lang.lab_paperownerapp')
                } else if (
                  this.tableData[i].beginSource === 3 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperPropertyapp')
                } else if (
                  this.tableData[i].beginSource === 5 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperGBA')
                } else if (this.tableData[i].beginSource === 6) {
                  beginSource = this.$i18n.t('lang.lab_paperBoard')
                }
              } else if (this.showingPage === 'allMaintainQuartzJob') {
                // 全项目自动巡检报事方式
                if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId === 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperlast')
                } else if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId > 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperauto')
                } else if (this.tableData[i].beginSource === 2) {
                  beginSource = this.$i18n.t('lang.lab_paperownerapp')
                } else if (
                  this.tableData[i].beginSource === 3 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperPropertyapp')
                }
              } else if (this.showingPage === 'maintainInfo') {
                // 报事信息报事方式
                if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId === 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperlast')
                } else if (
                  this.tableData[i].beginSource === 1 &&
                  this.tableData[i].quartzJobId > 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperauto')
                } else if (this.tableData[i].beginSource === 2) {
                  beginSource = this.$i18n.t('lang.lab_paperownerapp')
                } else if (
                  this.tableData[i].beginSource === 3 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperPropertyapp')
                } else if (
                  this.tableData[i].beginSource === 5 &&
                  this.tableData[i].quartzJobId == 0
                ) {
                  beginSource = this.$i18n.t('lang.lab_paperGBA')
                }
              }
              // 判断报事类型是否存在
              if (this.tableData[i].maintainType1.name) {
                maintainType1 = this.tableData[i].maintainType1.name
              } else {
                maintainType1 = ''
              }
              if (this.tableData[i].maintainType2 && this.tableData[i].maintainType2.name) {
                maintainType2 = this.tableData[i].maintainType2.name
              } else {
                maintainType2 = ''
              }
              if (this.tableData[i].maintainType3 && this.tableData[i].maintainType3.name) {
                maintainType3 = this.tableData[i].maintainType3.name
              } else {
                maintainType3 = ''
              }
              if (this.tableData[i].maintainType4 && this.tableData[i].maintainType4.name) {
                maintainType4 = this.tableData[i].maintainType4.name
              } else {
                maintainType4 = ''
              }
              // 判断事件性质，事件类别
              if (this.tableData[i].complainFlag === 0) {
                complainFlag = this.$i18n.t('lang.lab_papereno')
              } else if (this.tableData[i].complainFlag === 1) {
                complainFlag = this.$i18n.t('lang.lab_papereconsult')
              } else if (this.tableData[i].complainFlag === 2) {
                complainFlag = this.$i18n.t('lang.lab_paperecomplaint')
              } else if (this.tableData[i].complainFlag === 3) {
                complainFlag = this.$i18n.t('lang.lab_paperecommend')
              }
              // 判断工单属性
              if (
                this.showingPage === 'allMaintain' ||
                this.showingPage === 'allMaintainQuartzJob' ||
                this.showingPage === 'maintainInfo'
              ) {
                if (this.tableData[i].property === 0) {
                  property = this.$i18n.t('lang.lab_property0Abbr')
                } else if (this.tableData[i].property === 1) {
                  property = this.$i18n.t('lang.lab_property1Abbr')
                } else if (this.tableData[i].property === 2) {
                  property = this.$i18n.t('lang.lab_property2Abbr')
                } else if (this.tableData[i].property === 3) {
                  property = this.$i18n.t('lang.lab_property3Abbr')
                } else if (this.tableData[i].property === 4) {
                  property = this.$i18n.t('lang.lab_property4Abbr')
                }
                if (this.tableData[i].isOvertime === 1) {
                  property =
                    property + ',' + this.$i18n.t('lang.lab_isOvertime1Abbr')
                }
                if (this.tableData[i].state === 5) {
                  property = property + ',' + this.$i18n.t('lang.lab_state5Abbr_1')
                }
                if (this.tableData[i].isFollow === 2) {
                  property =
                    property + ',' + this.$i18n.t('lang.lab_isFollow2Abbr')
                }
                if (this.tableData[i].isCheck === 1) {
                  property = property + ',' + this.$i18n.t('lang.lab_isCheck1Abbr')
                } else if (this.tableData[i].isCheck === 2) {
                  property = property + ',' + this.$i18n.t('lang.lab_isCheck2Abbr')
                }
                if (this.showingPage === 'allMaintainQuartzJob') {
                  if (this.tableData[i].haveChild === 1) {
                    property =
                      property + ',' + this.$i18n.t('lang.lab_haveChild1Abbr')
                  }
                }
                if (this.showingPage === 'maintainInfo') {
                  if (this.tableData[i].state === 6) {
                    property =
                      property + ',' + this.$i18n.t('lang.lab_state6Abbr_1')
                  }
                  if (this.tableData[i].isValet === 1) {
                    property =
                      property + ',' + this.$i18n.t('lang.lab_isValet1Abbr')
                  }
                  if (this.tableData[i].isInspect === 1) {
                    property =
                      property + ',' + this.$i18n.t('lang.lab_isInspect1Abbr')
                  }
                  if (this.tableData[i].isCopyToMe === 1) {
                    property =
                      property + ',' + this.$i18n.t('lang.lab_isCopyToMe1Abbr')
                  }
                  if (this.tableData[i].parentId) {
                    property =
                      property + ',' + this.$i18n.t('lang.lab_haveParentIdAbbr')
                  }
                }
              }
              // 判断工单状态
              if (this.tableData[i].state === 0) {
                state = this.$i18n.t('lang.lab_paperereportingstate')
              } else if (this.tableData[i].state === 1) {
                state = this.$i18n.t('lang.lab_papereconfirmed')
              } else if (this.tableData[i].state === 2) {
                state = this.$i18n.t('lang.lab_paperesolved')
              } else if (this.tableData[i].state === 3) {
                state = this.$i18n.t('lang.lab_paperefinsh')
              } else if (this.tableData[i].state === 4) {
                state = this.$i18n.t('lang.lab_paperealreadyevaluated')
              } else if (this.tableData[i].state === 5) {
                state = this.$i18n.t('lang.lab_paperecloses')
              } else if (this.tableData[i].state === 6) {
                state = this.$i18n.t('lang.lab_paperenoclose')
              }
              // 判断满意度
              if (this.tableData[i].evaluate === 0) {
                evaluate = this.$i18n.t('lang.lab_paperevaluateres')
              } else if (this.tableData[i].evaluate === 1) {
                evaluate = this.$i18n.t('lang.lab_paperevaluateyes')
              } else if (this.tableData[i].evaluate === 2) {
                evaluate = this.$i18n.t('lang.lab_paperevaluatesoso')
              } else if (this.tableData[i].evaluate === 3) {
                evaluate = this.$i18n.t('lang.lab_paperenovaluate')
              }
              // 判断数量
              if (this.showingPage === 'allMaintainQuartzJob') {
                stateCount =
                  this.tableData[i].finishStateCount +
                  '/' +
                  this.tableData[i].errorStateCount +
                  '/' +
                  this.tableData[i].missStateCount +
                  '/' +
                  this.tableData[i].allStateCount
              }
              // 400报事页面表格数据
              if (this.showingPage === 'fourhundred') {
                newArr.push({
                  id: this.tableData[i].id,
                  userName: userName,
                  'garden.name': gardenName,
                  beginSource: beginSource,
                  timestampymdhis: this.tableData[i].createTime,
                  'garden.grids.houseName': houseName,
                  'garden.grids.unitName': unitName,
                  'garden.grids.roomName': roomName,
                  'maintainType1.name': maintainType1,
                  complainFlag: complainFlag,
                  state: state,
                  staffId: this.tableData[i].staffId != 0 ?
                    this.tableData[i].staff.idNo : '',
                  content: this.tableData[i].content,
                  evaluate: evaluate
                })
              } else if (this.showingPage === 'allMaintain') {
                // 全项目报事信息页面 表格数据
                newArr.push({
                  id: this.tableData[i].id,
                  userName: userName,
                  'garden.name': gardenName,
                  beginSource: beginSource,
                  timestampymdhis: this.tableData[i].createTime,
                  'garden.grids.houseName': houseName,
                  'garden.grids.unitName': unitName,
                  'garden.grids.roomName': roomName,
                  'maintainType1.name': maintainType1,
                  'maintainType2.name': maintainType2,
                  'maintainType3.name': maintainType3,
                  'maintainType4.name': maintainType4,
                  complainFlag: complainFlag,
                  property: property,
                  state: state,
                  staffId: this.tableData[i].staffId != 0 ?
                    this.tableData[i].staff.idNo : '',
                  content: this.tableData[i].content,
                  evaluate: evaluate,
                  gardenGridName: this.tableData[i].gardenGridName
                })
              } else if (this.showingPage === 'allMaintainQuartzJob') {
                // 全项目自动巡检页面 表格数据
                newArr.push({
                  id: this.tableData[i].id,
                  userName: userName,
                  'garden.name': gardenName,
                  beginSource: beginSource,
                  timestampymdhis: this.tableData[i].createTime,
                  endDate: this.$options.filters.time(this.tableData[i].endDate),
                  'garden.grids.houseName': houseName,
                  'garden.grids.unitName': unitName,
                  'garden.grids.roomName': roomName,
                  'maintainType1.name': maintainType1,
                  'maintainType2.name': maintainType2,
                  'maintainType3.name': maintainType3,
                  'maintainType4.name': maintainType4,
                  complainFlag: complainFlag,
                  property: property,
                  state: state,
                  staffId: this.tableData[i].staffId != 0 ?
                    this.tableData[i].staff.idNo : '',
                  content: this.tableData[i].content,
                  evaluate: evaluate,
                  gardenGridName: this.tableData[i].gardenGridName,
                  finishStateCount: stateCount
                })
              } else if (this.showingPage === 'maintainInfo') {
                // 报事信息 表格数据
                newArr.push({
                  id: this.tableData[i].id,
                  userName: userName,
                  'garden.name': gardenName,
                  beginSource: beginSource,
                  timestampymdhis: this.tableData[i].createTime,
                  'garden.grids.houseName': houseName,
                  'garden.grids.unitName': unitName,
                  'garden.grids.roomName': roomName,
                  'maintainType1.name': maintainType1,
                  'maintainType2.name': maintainType2,
                  'maintainType3.name': maintainType3,
                  'maintainType4.name': maintainType4,
                  complainFlag: complainFlag,
                  property: property,
                  state: state,
                  staffId: this.tableData[i].staffId != 0 ?
                    this.tableData[i].staff.idNo : '',
                  content: this.tableData[i].content,
                  evaluate: evaluate,
                  gardenGridName: this.tableData[i].gardenGridName
                })
              }
            }
          }

          // Excel表头 400报事
          if (this.showingPage === 'fourhundred') {
            const tHeader = [
              this.$i18n.t('lang.lab_Id'),
              this.$i18n.t('lang.lab_paperusername'),
              this.$i18n.t('lang.lab_papergarden'),
              this.$i18n.t('lang.lab_papertype'),
              this.$i18n.t('lang.lab_papertime'),
              this.$i18n.t('lang.lab_paperhouse'),
              this.$i18n.t('lang.lab_paperunit'),
              this.$i18n.t('lang.lab_paperroom'),
              this.$i18n.t('lang.lab_papertypes'),
              '报事类型II',
              '报事类型III',
              '报事类型Ⅳ',
              this.$i18n.t('lang.lab_papernatureofaffairs'),
              this.$i18n.t('lang.lab_paperestate'),
              this.$i18n.t('lang.lab_paperpeople'),
              this.$i18n.t('lang.lab_papercontent'),
              this.$i18n.t('lang.lab_paperevaluate')
            ]
            const filterVal = [
              'id',
              'userName',
              'garden.name',
              'beginSource',
              'timestampymdhis',
              'garden.grids.houseName',
              'garden.grids.unitName',
              'garden.grids.roomName',
              'maintainType1.name',
              'maintainType2.name',
              'maintainType3.name',
              'maintainType4.name',
              'complainFlag',
              'state',
              'staffId',
              'content',
              'evaluate'
            ]
            excelDownload(
              tHeader,
              filterVal,
              newArr,
              this.$i18n.t('lang.lab_400ReportInformation')
            )
          } else if (this.showingPage === 'allMaintain') {
            // Excel表头 全项目报事信息
            const tHeader = [
              this.$i18n.t('lang.lab_Id'),
              this.$i18n.t('lang.lab_paperusername'),
              this.$i18n.t('lang.lab_papergarden'),
              this.$i18n.t('lang.lab_mainSource'),
              this.$i18n.t('lang.lab_papertime'),
              this.$i18n.t('lang.lab_paperhouse'),
              this.$i18n.t('lang.lab_paperunit'),
              this.$i18n.t('lang.lab_paperroom'),
              this.$i18n.t('lang.lab_papertypes'),
              '报事类型II',
              '报事类型III',
              '报事类型Ⅳ',
              this.$i18n.t('lang.lab_complainFlagofType'),
              this.$i18n.t('lang.lab_papereProperty'),
              this.$i18n.t('lang.lab_paperestate'),
              this.$i18n.t('lang.lab_paperpeople'),
              this.$i18n.t('lang.lab_papercontent'),
              this.$i18n.t('lang.lab_paperevaluate'),
              '管家'
            ]
            const filterVal = [
              'id',
              'userName',
              'garden.name',
              'beginSource',
              'timestampymdhis',
              'garden.grids.houseName',
              'garden.grids.unitName',
              'garden.grids.roomName',
              'maintainType1.name',
              'maintainType2.name',
              'maintainType3.name',
              'maintainType4.name',
              'complainFlag',
              'property',
              'state',
              'staffId',
              'content',
              'evaluate',
              'gardenGridName'
            ]
            excelDownload(
              tHeader,
              filterVal,
              newArr,
              this.$i18n.t('lang.lab_fullProjectReportInformation')
            )
          } else if (this.showingPage === 'allMaintainQuartzJob') {
            // Excel表头 全项目自动巡检报事
            const tHeader = [
              this.$i18n.t('lang.lab_Id'),
              this.$i18n.t('lang.lab_paperusername'),
              this.$i18n.t('lang.lab_papergarden'),
              this.$i18n.t('lang.lab_mainSource'),
              this.$i18n.t('lang.lab_papertime'),
              '结束时间',
              this.$i18n.t('lang.lab_paperhouse'),
              this.$i18n.t('lang.lab_paperunit'),
              this.$i18n.t('lang.lab_paperroom'),
              this.$i18n.t('lang.lab_papertypes'),
              '报事类型II',
              '报事类型III',
              '报事类型Ⅳ',
              this.$i18n.t('lang.lab_papernatureofaffairs'),
              this.$i18n.t('lang.lab_papereProperty'),
              this.$i18n.t('lang.lab_paperestate'),
              this.$i18n.t('lang.lab_paperpeople'),
              this.$i18n.t('lang.lab_papercontent'),
              this.$i18n.t('lang.lab_paperevaluate'),
              '管家',
              this.$i18n.t('lang.lab_stateCount')
            ]
            const filterVal = [
              'id',
              'userName',
              'garden.name',
              'beginSource',
              'timestampymdhis',
              'endDate',
              'garden.grids.houseName',
              'garden.grids.unitName',
              'garden.grids.roomName',
              'maintainType1.name',
              'maintainType2.name',
              'maintainType3.name',
              'maintainType4.name',
              'complainFlag',
              'property',
              'state',
              'staffId',
              'content',
              'evaluate',
              'gardenGridName',
              'finishStateCount'
            ]
            excelDownload(
              tHeader,
              filterVal,
              newArr,
              this.$i18n.t('lang.lab_fullProjectAutomaticInspectionReport')
            )
          } else if (this.showingPage === 'maintainInfo') {
            // Excel表头 报事信息
            const tHeader = [
              this.$i18n.t('lang.lab_Id'),
              this.$i18n.t('lang.lab_paperusername'),
              this.$i18n.t('lang.lab_papergarden'),
              this.$i18n.t('lang.lab_mainSource'),
              this.$i18n.t('lang.lab_papertime'),
              this.$i18n.t('lang.lab_paperhouse'),
              this.$i18n.t('lang.lab_paperunit'),
              this.$i18n.t('lang.lab_paperroom'),
              this.$i18n.t('lang.lab_papertypes'),
              '报事类型II',
              '报事类型III',
              '报事类型Ⅳ',
              this.$i18n.t('lang.lab_papernatureofaffairs'),
              this.$i18n.t('lang.lab_papereProperty'),
              this.$i18n.t('lang.lab_paperestate'),
              this.$i18n.t('lang.lab_paperpeople'),
              this.$i18n.t('lang.lab_papercontent'),
              this.$i18n.t('lang.lab_paperevaluate'),
              '管家'
            ]
            const filterVal = [
              'id',
              'userName',
              'garden.name',
              'beginSource',
              'timestampymdhis',
              'garden.grids.houseName',
              'garden.grids.unitName',
              'garden.grids.roomName',
              'maintainType1.name',
              'maintainType2.name',
              'maintainType3.name',
              'maintainType4.name',
              'complainFlag',
              'property',
              'state',
              'staffId',
              'content',
              'evaluate',
              'gardenGridName'
            ]
            excelDownload(
              tHeader,
              filterVal,
              newArr,
              this.$i18n.t('lang.lab_reportInformation')
            )
          }
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 180000毫秒定时刷新
      startTimer() {
        let that = this
        clearInterval(that.timeOut)
        that.timeOut = setInterval(function () {
          that.maintains()
        }, 300000)
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // CHECKBOX
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 查询list
      maintains() {
        var startTs = ''
        var endTs = ''
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
          }
        }
        let loading = this.$loading()
        var userId = ''
        if (this.myLaunch === true) {
          userId = this.userDataId
        }
        this.$get(
          `/maintains?gardenId=${this.value}&houseIds=${this.floorid}&unitId=${this.unitid}&roomId=${this.roomid}&maintainTypeId1=${this.firstLevelid}&maintainTypeId2=${this.secondLevelid}&maintainTypeId3=${this.thirdLevelid}&maintainTypeId4=${this.fourthLevelid}&maintainTypeId5=${this.fifthLevelid}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&hasComplain=${this.hasComplain}&state=${this.state}&mainSource=${this.mainSource}&isQuartzJob=${this.isQuartzJob}&patrolStandard=${this.patrolStandard}&isCheck=${this.isCheck}&isRandom=${this.isRandom}&isEndCondition=${this.isEndCondition}&evaluate=${this.evaluate}&startTs=${startTs}&endTs=${endTs}&isOvertime=${this.isOvertime}&keyword=${this.keyword.trim()}&staffName=${this.staffName.trim()}&sendName=${this.sendName.trim()}&complainFlag=${this.complainFlag}&complainFlag2=${this.complainFlag2}&propertyStatus=${this.propertyStatus}&hasPic=${this.hasPic}&isInTime=${this.isInTime}&isValet=${this.isValet}&isInspect=${this.isInspect}&haveParent=${this.haveParent}&haveChild=${this.haveChild}&isEagleEye=${this.isEagleEye}&userId=${userId}&SetUp=${this.gradeEvaluation}&venueId=${this.venueId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
         if (this.handleType == 'child') {
          this.haveChildId(this.childId)
        } else {
          this.maintains()
        }
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        if (this.handleType == 'child') {
          this.haveChildId(this.childId)
        } else {
          this.maintains()
        }
      },
      // 小区下拉
      myGarden() {
        let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }        
        this.gardens = myGardens
        this.gardens.unshift({
          id: 0,
          name: '请选择小区'
        })
      },
      // 小区下拉
      cloundGardens() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              res.list.unshift({
                id: 0,
                name: '请选择小区'
              })
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 报事服务分类list
      maintainTypes() {
        this.$get(
          `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=${this.pageNum}&parentId=${this.value}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.typeleval === 1) {
                this.firstLevellist = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过级别id查询下一级别list
      levalmaintainTypes(Pid) {
        let loading = this.$loading()
        this.$get(
          `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=${this.pageNum}&Pid=${Pid}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.typeleval === 2) {
                this.secondLevellist = res.list
              } else if (this.typeleval === 3) {
                this.thirdLevellist = res.list
              } else if (this.typeleval === 4) {
                this.fourthLevellist = res.list
              } else if (this.typeleval === 5) {
                this.fifthLevellist = res.list
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      jump() {
        if (this.showingPage === 'fourhundred') {
          this.$router.push({
            name: '400backgroundSupply'
          })
        } else if (this.showingPage === 'allMaintainQuartzJob') {
          this.$router.push({
            name: 'fullprojectAutoInspecRepoBackgroundSupply'
          })
        } else if (this.showingPage === 'allMaintain') {
          this.$router.push({
            name: 'projectWideRepoInfoBackgroundSupply'
          })
        } else if (this.showingPage === 'maintainInfo') {
          this.$router.push({
            name: 'repoInfoBackgroundSupply'
          })
        }
      },
      commit() {
        sessionStorage.removeItem('haveChildParentId')
        this.trialDetailList = false
        this.pageNum = 1
        this.handleType = ''
        this.maintains()
      },
      // 操作详情
      detail(id, haveChild) {
        let that = this
        clearInterval(that.timeOut)
        if (this.showingPage === 'fourhundred') {
          this.$router.push({
            name: '400backgroundDetail',
            query: {
              id: id
            }
          })
        } else if (this.showingPage === 'allMaintainQuartzJob') {
          this.$router.push({
            name: 'fullprojectAutoInspecRepoBackgroundDetail',
            query: {
              id: id,
              haveChild: haveChild == 1 ? 1 : 0
            }
          })
        } else if (this.showingPage === 'allMaintain') {
          this.$router.push({
            name: 'projectWideRepoInfoBackgroundDetail',
            query: {
              id: id,
              haveChildParentId: this.haveChildParentId,
              trialDetailList: this.trialDetailList
            }
          })
        } else if (this.showingPage === 'maintainInfo') {
          this.$router.push({
            name: 'repoInfoBackgroundDetail',
            query: {
              id: id
            }
          })
        }
      },
      // 详情右键跳转新链接
      jumpNewLink(id) {
        let that = this
        clearInterval(that.timeOut)
        if (this.showingPage === 'fourhundred') {
          const {
            href
          } = this.$router.resolve({
            name: '400backgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        } else if (this.showingPage === 'allMaintainQuartzJob') {
          const {
            href
          } = this.$router.resolve({
            name: 'fullprojectAutoInspecRepoBackgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        } else if (this.showingPage === 'allMaintain') {
          const {
            href
          } = this.$router.resolve({
            name: 'projectWideRepoInfoBackgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        } else if (this.showingPage === 'maintainInfo') {
          const {
            href
          } = this.$router.resolve({
            name: 'repoInfoBackgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        }
      },
      // id查询楼号楼层房间号
      gardenGrids(gardenid) {
        if (gardenid === '0' || gardenid === '') {
          return
        }
        // let loading = this.$loading()
        this.$get(
          `/gardenGrids?type=${this.type}&pageSize=999&pageNo=${this.pageNum}&parentId=${gardenid}`
        ).then(
          res => {
            // loading.close()
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.floorList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
              } else if (this.type === 3) {
                this.roomList = res.list
              }
            }
          },
          error => {
            // loading.close()
            this.$message.error(error)
          }
        )
      },
      // 通过小区选择楼号
      selectFloor(value) {
        this.type = 1
        this.floorid = '0'
        this.unitid = '0'
        this.roomid = '0'
        this.unitList = []
        this.roomList = []
        this.floorList = []
        this.gardenGrids(this.value)
      },
      // 通过楼层选择单元号
      selectUnit(value) {
        this.type = 2
        this.unitid = '0'
        this.roomid = '0'
        this.roomList = []
        this.unitList = []
        if (value.length == 1) {
          this.gardenGrids(this.floorid)
        }
      },
      // 通过单元选择房间号
      selectRoom(value) {
        this.roomList = []
        this.type = 3
        this.roomid = '0'
        this.gardenGrids(this.unitid)
      },
      // 通过一级别查询二级下拉list
      selectSecond(value) {
        this.typeleval = 2
        this.levalmaintainTypes(this.firstLevelid)
        this.secondLevelid = '0'
        this.thirdLevelid = '0'
        this.thirdLevellist = []
        this.fourthLevelid = '0'
        this.fourthLevellist = []
        this.fifthLevelid = '0'
        this.fifthLevellist = []
      },
      // 通过二级别查询三级下拉list
      selectThird(value) {
        this.typeleval = 3
        this.levalmaintainTypes(this.secondLevelid)
        this.thirdLevelid = '0'
        this.fourthLevelid = '0'
        this.fourthLevellist = []
        this.fifthLevelid = '0'
        this.fifthLevellist = []
      },
      // 通过三级别查询四级下拉list
      selectFourth(value) {
        this.typeleval = 4
        this.levalmaintainTypes(this.thirdLevelid)
        this.fourthLevelid = '0'
        this.fifthLevelid = '0'
        this.fifthLevellist = []
      },
      // 通过四级别查询五级下拉list
      selectFifth(value) {
        this.typeleval = 5
        this.levalmaintainTypes(this.fourthLevelid)
        this.fifhtLevelid = '0'
      },
      // 清空查询条件
      clean() {
        this.datevalues = '' // 开始结束时间绑定值
        this.isEndCondition = '' // 工单完结绑定值
        this.value = '0' // 小区绑定值
        this.floorid = '0' // 楼层绑定值
        this.unitid = '0' // 单元绑定值
        this.roomid = '0' // 房间绑定值
        this.firstLevelid = '0' // 一级分类绑定id
        this.secondLevelid = '0' // 二级分类绑定id
        this.thirdLevelid = '0' // 三级分类绑定id
        this.fourthLevelid = '0' // 四级分类绑定id
        this.fifthLevelid = '0' // 五级分类绑定id
        this.isOvertime = '' // 是否超时绑定值
        this.state = '0' // 工单状态绑定值
        this.evaluate = '' // 满意度绑定值
        this.complainFlag = '' // 事件性质绑定值
        this.keyword = '' // 手机或序号内容input
        this.staffName = '' // 接单人input
        this.sendName = '' // 报单人input
        this.pageNum = 1 // 第几页
        this.pageSize = 10 // 每页显示数
        this.type = 1 // 楼号单元号房间号区分
        this.refresh = '2' // 刷新按钮变成关闭
        if (this.showingPage === 'fourhundred') {
          this.mainSource = 4
        } else {
          this.mainSource = '' // 报事来源绑定值
        }
        this.patrolStandard = '' // 巡检标准绑定值
        this.isCheck = '' // 是否审阅绑定值
        this.isRandom = '' // 是否抽审绑定值
        this.propertyStatus = '' // 处理状态绑定值
        this.hasPic = '' // 是否审阅绑定值
        this.isInTime = '' // 是否24小时绑定值
        this.isValet = '' // 是否代客报事绑定值
        this.isInspect = '' // 是否稽查工单绑定值
        this.haveParent = '' // 是否有父工单绑定值
        this.haveChild = '' // 是否有子工单绑定值
        this.isEagleEye = '' // 是否鹰眼报事
      },
      // 刷新
      refresh1() {
        // 刷新当前页面
        if (this.refresh === '0') {
          this.clean()
          this.value = this.refreshValue
          this.maintains()
          // 开启刷新
        } else if (this.refresh === '1') {
          let that = this
          that.startTimer()
          // 关闭刷新
        } else if (this.refresh === '2') {
          let that = this
          clearInterval(that.timeOut)
        }
      },
      showPhotos(id) {
        this.$get(`/maintainsFileCountById/` + id).then(
          res => {
            if (res && res.errCode === 0) {
              if (res.photoCount > 0) {
                this.showPhotoBefore(id)
              } else {
                this.$message.error(this.$i18n.t('lang.lab_noPhotoCount'))
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 处理前照片 
      showPhotoBefore(id) {
        this.editId = id
        this.show = true
        let loading = this.$loading()
        this.$get(`/maintainsFile/` + id + '/1').then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.uris = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
        this.showPhotoAfter(id)
      },
      // 处理后照片
      showPhotoAfter(id) {
        this.editId = id
        this.show = true
        let loading = this.$loading()
        this.$get(`/maintainsFile/` + id + '/2').then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.uris_af = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 工单评价等级显示
      showSetting(row) {
        this.gradeRadio = '0'
        this.gradeRemark = ''
        this.settingDialogVisible = true
        this.maintainId = row.id
        if (row.setUp != '' && row.setUp != undefined) {
            this.gradeRadio = row.setUp + ''
        }
        this.gradeRemark = row.annotation
      },
      // 工单评价等级确定
      settingConfim() {
        if (this.gradeRemark.trim() == '' && this.gradeRadio !== '0') {
          this.$message.error('请输入工单等级评价批注')
        } else {
          this.settingDialogVisible = false
          let loading = this.$loading()
          let param = {
              SetUp: this.gradeRadio,
              Annotation: this.gradeRemark
          }
          this.$post(`/saveSettingConfirm/` + this.maintainId, param).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.maintains()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 工单评价等级取消
      settingCancel() {
        this.settingDialogVisible = false
      },
      // 删除工单
      deleteOne(row) {
        this.$confirm('确认要删除该工单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let loading = this.$loading()
          this.$delete(`/maintains/${row.id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.pageNum = 1
                  this.maintains()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  .newspaperInfoList {
    .el-range-editor.el-input__inner {
      width: 370px;
    }

    .filters {
      padding: 5px 20px;
    }

    .m-0 {
      margin: 0;
    }

    .filters .telidcon .el-input__inner {
      width: 180px;
    }

    .el-collapse-item__header {
      border-bottom: 0px;
    }

    .el-collapse {
      border-top: 0px;
    }

    .property0style {
      border: 1px solid#CD69C9;
      color: #cd69c9;
    }

    .property1style {
      border: 1px solid#00FF00;
      color: #00ff00;
    }

    .property2style {
      border: 1px solid#CD950C;
      color: #cd950c;
    }

    .property3style {
      border: 1px solid#CD2990;
      color: #cd2990;
    }

    .property4style {
      border: 1px solid#66DAFF;
      color: #66daff;
    }

    .isOvertime1style {
      margin-left: 2px;
      border: 1px solid#FF0000;
      color: #ff0000;
    }

    .state5style {
      margin-left: 2px;
      border: 1px solid#E7003E;
      color: #e7003e;
    }

    .state6style {
      margin-left: 2px;
      border: 1px solid#E7003E;
      color: #e7003e;
    }

    .isFollow2style {
      margin-left: 2px;
      border: 1px solid#FF9900;
      color: #ff9900;
    }

    .isCheck1style {
      margin-left: 2px;
      border: 1px solid#8C8C8C;
      color: #8c8c8c;
    }

    .isCheck0style {
      margin-left: 2px;
      border: 1px solid#8C8C8C;
      color: #8c8c8c;
    }

    .isCheck1style {
      margin-left: 2px;
      border: 1px solid #67C23A;
      color: #67C23A;
    }

    .isCheck2style {
      margin-left: 2px;
      border: 1px solid#E7003E;
      color: #E7003E;
    }

    .isValet1style {
      margin-left: 2px;
      border: 1px solid #8b00ff;
      color: #8b00ff;
    }

    .isInspect1style {
      margin-left: 2px;
      border: 1px solid #555555;
      color: #555555;
    }

    .isCopyToMe1style {
      margin-left: 2px;
      border: 1px solid #87ceff;
      color: #87ceff;
    }

    .haveChild1style {
      margin-left: 2px;
      border: 1px solid #4682b4;
      background-color: #4682b4;
      color: #ffffff;
      cursor: pointer;
    }

    .haveParentIdstyle {
      margin-left: 2px;
      border: 1px solid #668b8b;
      background-color: #668b8b;
      color: #ffffff;
      cursor: pointer;
    }

    .conctentstyle {
      color: #4a88b0;
    }

    .operation {
      margin-right: 0px;
    }
  }

  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .img {
    width: 50px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }

  .gradeRadio {
    padding: 10px 20px;
  }

  .gradeRadioLabel {
    margin-right: 20px;
  }

  .gradeRemarkBox {
    display: flex;
    padding: 10px 20px;
  }

  .gradeRemark {
    padding: 10px;
    box-sizing: border-box;
  }

  .gradeStar {
    margin-top: 15px;
    color: red;
  }
</style>